// frontend/src/pages/ForgotPassword.jsx

import React, { useState } from 'react';
import api from '../services/api';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        try {
            const res = await api.post('/auth/request-reset-password', { email });
            setMessage(res.data.msg);
        } catch (err) {
            console.error('Erro ao solicitar redefinição de senha:', err);
            setError(err.response?.data?.msg || 'Erro ao solicitar redefinição de senha.');
        }
    };

    return (
        <div
            className="w-screen h-screen flex justify-center items-center bg-cover bg-center"
            style={{
                backgroundImage: `url('/images/login_background.png')`,
            }}
        >
            {/* Formulário de Recuperação de Senha */}
            <div className="w-[406px] p-6 bg-white rounded-lg border border-slate-300 flex flex-col justify-center items-center gap-6">
                {/* Título */}
                <h2 className="text-2xl font-medium text-stone-800">Recuperar Senha</h2>

                {/* Mensagem de Sucesso */}
                {message && <p className="text-green-600">{message}</p>}

                {/* Mensagem de Erro */}
                {error && <p className="text-red-600">{error}</p>}

                {/* Formulário */}
                {!message && (
                    <form onSubmit={handleSubmit} className="w-full">
                        {/* Campo de E-mail */}
                        <div className="flex flex-col gap-1 mb-4">
                            <label htmlFor="email" className="text-slate-700 text-sm font-medium">
                                E-mail
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Digite seu e-mail"
                            />
                        </div>

                        {/* Botão de Enviar */}
                        <button
                            type="submit"
                            className="w-full px-4 py-2 bg-stone-600 text-white rounded-md hover:bg-stone-700 transition duration-200"
                        >
                            Enviar Link de Redefinição
                        </button>
                    </form>
                )}

                {/* Link para a Página de Login */}
                <div className="mt-4">
                    <Link to="/login" className="text-blue-500 hover:underline">
                        Voltar para o Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
